import { Grid } from "@mui/material";
import React from "react";
import InvoiceHeader from "./home/header";
import InvoiceTable from "./home/table";

const Invoices = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <InvoiceHeader />
      </Grid>
      <Grid item xs={12}>
        <InvoiceTable />
      </Grid>
    </Grid>
  );
};

export default Invoices;
